import { render } from "./CapItaltwo.vue?vue&type=template&id=6a59e78a"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/CapItaltwo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a59e78a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a59e78a', __exports__)) {
    api.reload('6a59e78a', __exports__)
  }
  
  module.hot.accept("./CapItaltwo.vue?vue&type=template&id=6a59e78a", () => {
    api.rerender('6a59e78a', render)
  })

}


export default __exports__